import { render } from "./OpenMarketRegistrationView.vue.ts?vue&type=template&id=0985273d&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OpenMarketRegistrationView.vue?vue&type=template&id=0985273d&scoped=true&ts=true"
import script from "./OpenMarketRegistrationView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OpenMarketRegistrationView.vue?vue&type=script&lang=ts"
export * from "./OpenMarketRegistrationView.vue.ts?vue&type=script&lang=ts!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OpenMarketRegistrationView.vue?vue&type=script&lang=ts"

import "./OpenMarketRegistrationView.vue.scss?vue&type=style&index=0&id=0985273d&lang=scss&scoped=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OpenMarketRegistrationView.vue?vue&type=style&index=0&id=0985273d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0985273d"],['__file',"src/apps/core-app-onboarding/views/OpenMarketRegistrationView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0985273d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0985273d', __exports__)) {
    api.reload('0985273d', __exports__)
  }
  
  module.hot.accept("./OpenMarketRegistrationView.vue.ts?vue&type=template&id=0985273d&scoped=true&ts=true!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OpenMarketRegistrationView.vue?vue&type=template&id=0985273d&scoped=true&ts=true", () => {
    api.rerender('0985273d', render)
  })

}


export default __exports__